var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { Stepper } from "@opala-ds/react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useCreateCollectiveModality } from "../../queries/jepis";
import useCollectiveInstitutionStore from "../../stores/collectiveModalityStore";
import AddressDataForm from "../Forms/AddressDataForm";
import AthleteDataForm from "../Forms/collectiveModalityForms/AthleteDataForm";
import ModalityDataForm from "../Forms/collectiveModalityForms/ModalityDataForm";
import TechnicalCommitteeAssistantDataForm from "../Forms/collectiveModalityForms/TechnicalCommitteeAssistantDataForm";
import TechnicalCommitteeTechnicalDataForm from "../Forms/collectiveModalityForms/TechnicalCommitteeTechnicalDataForm";
import TermsAndConditionsCollectiveSchoolForm from "../Forms/collectiveModalityForms/TermsAndConditionsCollectiveSchoolForm";
import EducationalInstitutionDataForm from "../Forms/EducationalInstitutionDataForm";
export default function CollectiveModalityStepper() {
    var _a, _b;
    var educationalInstitutionData = useCollectiveInstitutionStore(function (state) { return state.educationalInstitutionData; });
    var addressData = useCollectiveInstitutionStore(function (state) { return state.addressData; });
    var modality = useCollectiveInstitutionStore(function (state) { return state.modality; });
    var technicalCommitteeTechnicalData = useCollectiveInstitutionStore(function (state) { return state.technicalCommitteeTechnicalData; });
    var athleteDataForm = useCollectiveInstitutionStore(function (state) { return state.athleteDataForm; });
    var setEducationalInstitutionData = useCollectiveInstitutionStore(function (state) { return state.setEducationalInstitutionData; });
    var setAddressData = useCollectiveInstitutionStore(function (state) { return state.setAddressData; });
    var setModality = useCollectiveInstitutionStore(function (state) { return state.setModality; });
    var pushTechnicalCommitteeTechnicalData = useCollectiveInstitutionStore(function (state) { return state.pushTechnicalCommitteeTechnicalData; });
    var setAthleteDataForm = useCollectiveInstitutionStore(function (state) { return state.setAthleteDataForm; });
    var setTermsAndConditionsData = useCollectiveInstitutionStore(function (state) { return state.setTermsAndConditionsData; });
    var tecnicoDefaults = ((_a = technicalCommitteeTechnicalData.comissao_tecnica) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
        var cpf = _a.cpf, funcao = _a.funcao;
        return cpf && funcao === "Técnico";
    })) || [];
    var assistenteDefaults = ((_b = technicalCommitteeTechnicalData.comissao_tecnica) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
        var cpf = _a.cpf, funcao = _a.funcao;
        return cpf && funcao === "Assistente";
    })) || [];
    var createCollectiveModality = useCreateCollectiveModality().mutate;
    var isMobile = useIsMobile();
    return (_jsx(Stepper, { showIndicator: !isMobile, initialStep: 0, orientation: "horizontal", steps: [
            {
                title: "Instituição de Ensino",
                content: (_jsx(EducationalInstitutionDataForm, { onSubmit: setEducationalInstitutionData, defaultValues: educationalInstitutionData })),
            },
            {
                title: "Endereço",
                content: (_jsx(AddressDataForm, { onSubmit: setAddressData, defaultValues: addressData })),
            },
            {
                title: "Modalidade",
                content: (_jsx(ModalityDataForm, { onSubmit: function (_a) {
                        var modalidade = _a.modalidade;
                        return setModality(modalidade);
                    }, defaultValues: { modalidade: modality } })),
            },
            {
                title: "Comissão Técnica - Técnico",
                content: (_jsx(TechnicalCommitteeTechnicalDataForm, { onSubmit: function (comissao_tecnica) {
                        var existingCommittee = (technicalCommitteeTechnicalData.comissao_tecnica || [])
                            .filter(function (member) {
                            return member.cpf && member.nome && member.rg && member.cref;
                        })
                            .map(function (member) { return ({
                            cpf: member.cpf,
                            rg: member.rg,
                            nome: member.nome,
                            cref: member.cref,
                            foto_arquivo: member.foto_arquivo,
                            funcao: member.funcao,
                        }); });
                        pushTechnicalCommitteeTechnicalData({
                            comissao_tecnica: __spreadArray(__spreadArray([], existingCommittee, true), comissao_tecnica.comissao_tecnica, true),
                        });
                    }, defaultValues: {
                        comissao_tecnica: tecnicoDefaults.length
                            ? tecnicoDefaults
                            : [
                                {
                                    nome: "",
                                    cpf: "",
                                    rg: "",
                                    cref: "",
                                    foto_arquivo: undefined,
                                    funcao: "Técnico",
                                },
                            ],
                    } })),
            },
            {
                title: "Comissão Técnica - Assistente",
                content: (_jsx(TechnicalCommitteeAssistantDataForm, { onSubmit: function (comissao_tecnica) {
                        var _a;
                        var allCommittee = (_a = comissao_tecnica.comissao_tecnica) === null || _a === void 0 ? void 0 : _a.concat(technicalCommitteeTechnicalData.comissao_tecnica || []);
                        pushTechnicalCommitteeTechnicalData({
                            comissao_tecnica: allCommittee,
                        });
                    }, defaultValues: {
                        comissao_tecnica: assistenteDefaults.length
                            ? assistenteDefaults
                            : [
                                {
                                    nome: "",
                                    cpf: "",
                                    rg: "",
                                    cref: "",
                                    foto_arquivo: undefined,
                                    funcao: "Assistente",
                                },
                            ],
                    } })),
            },
            {
                title: "Atletas",
                content: (_jsx(AthleteDataForm, { onSubmit: function (alunos_atletas) { return setAthleteDataForm(alunos_atletas); }, defaultValues: athleteDataForm })),
            },
            {
                title: "Aceite dos Termos e Condições",
                content: (_jsx(TermsAndConditionsCollectiveSchoolForm, { onSubmit: function (data) {
                        setTermsAndConditionsData(data);
                        createCollectiveModality({
                            payload: {
                                educationalInstitutionData: educationalInstitutionData,
                                addressData: addressData,
                                modality: modality,
                                technicalCommitteeTechnicalData: technicalCommitteeTechnicalData,
                                athleteDataForm: athleteDataForm,
                                termsAndConditionsData: data,
                            },
                        });
                    } })),
            },
        ], textAlignment: "center" }));
}
